import { Input } from "design-react-kit";
import React, { useEffect, useState, useContext } from "react";
import ModalComponent from "../../Components/ModalComponent";
import Repo from "../../Utility/Repo";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import { useLocation } from "react-router-dom";
import Select from "../../Components/Select";
import Loader from "../../Components/Loader";
import { TokenContext } from "../../Components/TokenContext";

import LabelsLoader from "../../Utility/labelsLoader";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function EditAnnouncement(props) {
  const apiToken = useContext(TokenContext);
  const d = new Date();
  const [serviceId, setServiceId] = useState();
  const [isOpen, toggleModal] = useState(false);
  const [serviceName, setServiceName] = useState();
  // const [rangesList, setRangesList] = useState([]);
  const [arrRanges1, setArrRanges1] = useState();
  const [arrRangesTemp1, setArrRangesTemp1] = useState([]);
  const [arrRanges2, setArrRanges2] = useState([]);
  const [arrRangesTemp2, setArrRangesTemp2] = useState([]);
  const [arrRangesFilter1, setArrRangesFilter1] = useState();
  const [validation, setValidation] = useState(false);
  const [servizi, setServizi] = useState([]);
  const [servizioTemp, setServizioTemp] = useState();
  const [versioneServizio, setVersioneServizio] = useState([]);

  const labels = LabelsLoader();

  const STATI = [
    { label: "Creato", value: 0, code: "CREATE" },
    { label: "Aperto", value: 1, code: "OPEN" },
    { label: "Chiuso", value: 2, code: "CLOSED" },
    { label: "Archiviato", value: 3, code: "ARCHIVED" },
  ];
  const mapStateFromBackend = (code) =>
    STATI.find((s) => s.code === code)?.value ?? null;

  const [loading, setLoading] = useState(true);
  const [session, setSession] = useState({});
  const [loadedRanges, setLoadedRanges] = useState(false);
  const [filterRange, setFilterRange] = useState();

  let query = useQuery();

  useEffect(() => {
    if (apiToken) {
      setLoading(false);

      if (query.get("sessionId")) {
        Repo.getSessionByIdUser(apiToken, query.get("sessionId")).then(
          (response) => {
            const data = response.data;

            setSession({
              ...data,
              state: mapStateFromBackend(data.state), // 🔥 QUI RISOLVI TUTTO
              serviceId: data.service?.id ?? null,
            });
          },
        );
      }

      Repo.getRangesList(apiToken)
        .then((response) => {
          setArrRanges1(response.data);
          setArrRangesFilter1(response.data);
          setLoadedRanges(true);
          setLoading(true);
        })
        .catch((error) => {
          console.log(error);
          setLoading(true);
        });

      Repo.getListaServizi(apiToken)
        .then((response) => {
          setServizi(response.data);
          setLoading(true);
        })
        .catch((error) => {
          console.log(error);
          setLoading(true);
        });

      Repo.getSelectVersioneServizio(apiToken)
        .then((response) => {
          console.log("OK getSelectVersioneServizio:", response);
          setVersioneServizio(response.data);
        })
        .catch((error) =>
          console.error("Errore getSelectVersioneServizio:", error),
        )
        .finally(() => setLoading(true));
    }
  }, []);

  useEffect(() => {
    if (session.bands && session.bands.length != 0 && arrRanges1) {
      setArrRanges2(session.bands);
      var rangesInit = arrRanges1.filter(function (obj) {
        return !session.bands.some(function (obj2) {
          return obj.id == obj2.id;
        });
      });
      setArrRanges1(rangesInit);
    }
  }, [session, loadedRanges]);

  const checkSession = () => {
    setValidation(true);
    let passedValidation = true;

    const temp = {
      id: null,
      name: null,
      cost: null,
      serviceId: null,
      bandsId: [],
      state: null,
      year: null,
      externalId: null,
      codAccertamento: null,
      codCapitolo: null,
      nomeMyPay: null,
      listBase64: [],
    };

    // ✅ SAFE CHECK (no crash)
    if (!session.serviceId && !session.service?.id) passedValidation = false;

    if (!session.name) passedValidation = false;
    if (!session.codAccertamento) passedValidation = false;
    if (!session.codCapitolo) passedValidation = false;
    if (!session.nomeMyPay) passedValidation = false;

    // 👉 bands safe
    temp.bandsId = arrRanges2?.map((x) => x.id) || [];

    temp.id = session.id;

    // 👉 serviceId safe
    temp.serviceId = session.service?.id ?? session.serviceId;

    temp.name = session.name;
    temp.codAccertamento = session.codAccertamento;
    temp.codCapitolo = session.codCapitolo;
    temp.nomeMyPay = session.nomeMyPay;
    temp.externalId = session.externalId;

    console.log("session.externalId:", session.externalId);

    // 🔥 FIX CRITICO
    temp.state = session.state; // DEVE GIÀ ESSERE NUMBER

    const parsedYear = parseInt(session.year, 10);
temp.year = isNaN(parsedYear) ? null : parsedYear;



    console.log("DTO pronto:", temp);

    // 👉 aggiorno session SOLO se valido
    if (passedValidation) {
      setSession(temp); // opzionale ma corretto
      toggleModal(!isOpen);
    }
  };

  const postUpdateSession = () => {
    console.log(JSON.stringify(session));
    Repo.postUpdateSession(apiToken, JSON.stringify(session))
      .then((response) => {
        if (response.status == 200) {
          window.location.href =
            props.subfolder +
            "/lista_bandi/dettaglio_sessione?id=" +
            query.get("sessionId");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleChangeRange = (event, percent, fixedcost) => {
    if (event) {
      let name = event.target.name;
      let id = event.target.id;
      let checked = event.target.checked;
      let value = event.target.value;

      switch (name) {
        case "checkBox1":
          if (checked) {
            setArrRangesTemp1((prevState) => [
              ...prevState,
              {
                id: id,
                name: value,
                percent: percent,
                fixedCost: fixedcost,
              },
            ]);
            break;
          } else {
            var arr = arrRangesTemp1.filter((item) => item.id !== id);

            setArrRangesTemp1(arr);

            break;
          }

        case "checkBox2":
          if (checked) {
            setArrRangesTemp2((prevState) => [
              ...prevState,
              {
                id: id,
                name: value,
                percent: percent,
                fixedCost: fixedcost,
              },
            ]);
            break;
          } else {
            var arr = arrRangesTemp2.filter((item) => item.id !== id);

            setArrRangesTemp2(arr);

            break;
          }

        default:
          break;
      }
    }
  };

  const transferRange = (bool) => {
    if (bool) {
      setArrRanges2(arrRanges2.concat(arrRangesTemp1));

      var arr = arrRanges1.filter(function (obj) {
        return !arrRangesTemp1.some(function (obj2) {
          return obj.id == obj2.id;
        });
      });

      var arr2 = arrRangesTemp1.filter(function (obj) {
        return !arrRanges1.some(function (obj2) {
          return obj.id == obj2.id;
        });
      });

      var result = arr.concat(arr2);

      setArrRanges1(result);
      setArrRangesTemp1([]);
    } else {
      setArrRanges1(arrRanges1.concat(arrRangesTemp2));

      var arr = arrRanges2.filter(function (obj) {
        return !arrRangesTemp2.some(function (obj2) {
          return obj.id == obj2.id;
        });
      });

      var arr2 = arrRangesTemp2.filter(function (obj) {
        return !arrRanges2.some(function (obj2) {
          return obj.id == obj2.id;
        });
      });

      var result = arr.concat(arr2);

      setArrRanges2(result);
      setArrRangesTemp2([]);
    }
  };

  useEffect(() => {
    if (filterRange && arrRanges1) {
      var arr = arrRanges1.filter(function (obj) {
        return obj.name.toLowerCase().includes(filterRange.toLowerCase());
      });
      setArrRanges1(arr);
    } else if (arrRangesFilter1) {
      var arr2 = arrRangesFilter1.filter(function (obj) {
        return !arrRanges2.some(function (obj2) {
          return obj.id == obj2.id;
        });
      });
      setArrRanges1(arr2);
    }
  }, [filterRange]);

  const transferBlock = () => {
    return (
      <>
        <div className="row mt-4">
          <div className="col-xs-12 col-md-5">
            <Input
              id="filterRange"
              label="Fasce Isee"
              type="text"
              name="filterRange"
              value={filterRange ? filterRange : ""}
              onChange={(e) => setFilterRange(e.target.value)}
            />
          </div>
        </div>
        <div className="it-transfer-block">
          <div className="row">
            <div className="col-xs-12 col-md-5">
              <div className="it-transfer-wrapper source">
                <div className="transfer-header">
                  <div className="form-check" aria-describedby="">
                    <label htmlFor="checkbox1">
                      <span>FASCE ISEE DISPONIBILI</span>
                    </label>
                  </div>
                </div>
                <div className="transfer-scroll">
                  <div className="transfer-group">
                    {arrRanges1 &&
                      arrRanges1.length > 0 &&
                      arrRanges1.map((x, index) => (
                        <div
                          key={x.id}
                          className="form-check"
                          aria-describedby=""
                        >
                          <input
                            id={x.id}
                            value={x.name}
                            type="checkbox"
                            name="checkBox1"
                            onChange={(e) =>
                              handleChangeRange(e, x.percent, x.fixedCost)
                            }
                            {...(arrRangesTemp1 &&
                            arrRangesTemp1.length > 0 &&
                            arrRangesTemp1.find((y) => y.id == x.id)
                              ? {
                                  checked: true,
                                }
                              : { checked: false })}
                          />
                          <label htmlFor={x.id}>
                            <span>
                              <span>
                                {typeof x.percent != "object" && x.percent
                                  ? x.name +
                                    " (" +
                                    x.percent +
                                    "% di " +
                                    x.fixedCost +
                                    " €)"
                                  : x.name + " (" + x.fixedCost + " €)"}
                              </span>
                            </span>
                          </label>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
            {/* Button */}
            <div className="col-xs-12 col-md-2">
              <div className="it-transfer-buttons">
                {arrRangesTemp1 && arrRangesTemp1.length > 0 ? (
                  <>
                    <button
                      className="transfer"
                      style={{
                        border: "1px solid #06c",
                        borderRadius: "50%",
                        cursor: "pointer",
                      }}
                      onClick={() => transferRange(true)}
                      aria-label="Sposta avanti"
                    >
                      <svg className="icon icon-primary">
                        <use href={`${iconSprite}#it-arrow-right`}></use>
                      </svg>
                    </button>
                    <span className="sr-only">Label for arrow right</span>{" "}
                  </>
                ) : (
                  <>
                    <button
                      className="transfer"
                      style={{
                        border: "1px solid gray",
                        borderRadius: "50%",
                        cursor: "not-allowed",
                      }}
                      aria-label="Sposta avanti"
                    >
                      <svg className="icon icon-info">
                        <use href={`${iconSprite}#it-arrow-right`}></use>
                      </svg>
                    </button>
                    <span className="sr-only">Label for arrow right</span>{" "}
                  </>
                )}

                {arrRangesTemp2 && arrRangesTemp2.length > 0 ? (
                  <>
                    <button
                      style={{
                        border: "1px solid #06c",
                        borderRadius: "50%",
                        cursor: "pointer !important",
                      }}
                      className="backtransfer mt-2"
                      href="#"
                      aria-label="Sposta indietro"
                      onClick={() => transferRange(false)}
                    >
                      <svg className="icon icon-primary">
                        <use href={`${iconSprite}#it-arrow-left`}></use>
                      </svg>
                    </button>
                    <span className="sr-only">Label for arrow left</span>
                  </>
                ) : (
                  <>
                    <button
                      className="backtransfer mt-2"
                      style={{
                        border: "1px solid gray",
                        borderRadius: "50%",
                        cursor: "not-allowed",
                      }}
                      aria-label="Sposta avanti"
                    >
                      <svg className="icon icon-info">
                        <use href={`${iconSprite}#it-arrow-left`}></use>
                      </svg>
                    </button>
                  </>
                )}
              </div>
            </div>
            <div className="col-xs-12 col-md-5">
              <div className="it-transfer-wrapper target">
                <div className="transfer-header">
                  <div className="form-check" aria-describedby="">
                    <label htmlFor="checkbox1b">
                      <span>
                        <span>FASCE ISEE SELEZIONATE</span>
                      </span>
                    </label>
                  </div>
                </div>
                <div className="transfer-scroll">
                  <div className="transfer-group">
                    {arrRanges2 &&
                      arrRanges2.length > 0 &&
                      arrRanges2.map((x, index) => (
                        <div
                          key={x.id}
                          className="form-check"
                          aria-describedby=""
                        >
                          <input
                            id={x.id}
                            value={x.name}
                            type="checkbox"
                            name="checkBox2"
                            onChange={(e) =>
                              handleChangeRange(e, x.percent, x.fixedCost)
                            }
                            {...(arrRangesTemp2 &&
                            arrRangesTemp2.length > 0 &&
                            arrRangesTemp2.find((y) => y.id == x.id)
                              ? {
                                  checked: true,
                                }
                              : { checked: false })}
                          />
                          <label htmlFor={x.id}>
                            <span>
                              {typeof x.percent != "object" && x.percent
                                ? x.name +
                                  " (" +
                                  x.percent +
                                  "% di " +
                                  x.fixedCost +
                                  " €)"
                                : x.name + " (" + x.fixedCost + " €)"}
                            </span>
                          </label>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      {console.log(session.state || "")}
      <h1>Modifica bando</h1>
      <div className="clearfix col-lg-8 py-lg-2">
        <p>Modifica il bando</p>
      </div>

      <div className="col-lg-12">
        <div className="card-wrapper card-space">
          <div className="card card-bg no-after roundedCustom">
            <div className="card-body p-5">
              <div className="row">
                <div className="col-lg-10">
                  <Input
                    id="title"
                    label="Titolo*"
                    type="text"
                    name="title"
                    value={session.name || session.name || ""}
                    onChange={(e) =>
                      setSession({ ...session, name: e.target.value })
                    }
                    {...(validation &&
                      !session.name && {
                        infoText: "Il campo non può essere vuoto!",
                        className: "text-danger error_div is-invalid",
                      })}
                  />
                </div>
                <div className="col-lg-2">
                  <Input
                    type="number"
                    id="anno"
                    label="Anno"
                    name="anno"
                    value={session.year ?? ""}
                    onChange={(e) =>
                      setSession((prev) => ({
                        ...prev,
                        year: e.target.value, // ← STRINGA
                      }))
                    }
                  />
                </div>
              </div>

              <div className="row">
                <div className="bootstrap-select-wrapper col-lg-6">
                  <Select
                    aria-label="Servizio"
                    clearText="Annulla"
                    defaultMenuIsOpen={false}
                    icon={false}
                    name="servizio"
                    id="servizio"
                    options={servizi}
                    onChange={(e) => {
                      setServizioTemp(e ? e.label : null);
                      setSession({ ...session, serviceId: e.value });
                      setServiceName();
                    }}
                    isClearable
                    isSearchable
                    value={session.serviceId || ""}
                    placeholder={
                      servizioTemp
                        ? servizioTemp
                        : serviceName
                          ? serviceName
                          : session.service
                            ? session.service.name
                            : "Seleziona servizio*"
                    }
                  />
                  {validation && !session.serviceId ? (
                    <small id="errorSelect" className="form-text text-danger">
                      Il campo non può essere vuoto!
                    </small>
                  ) : (
                    <></>
                  )}
                </div>

                <div className="bootstrap-select-wrapper col-lg-6">
                  <Select
                    aria-label="Stato bando"
                    options={STATI}
                    value={STATI.find((s) => s.value === session.state) || null}
                    onChange={(e) => {
                      setSession({
                        ...session,
                        state: e.value, // 🔥 NUMERO
                      });
                    }}
                    placeholder="Seleziona stato"
                  />

                  {validation && !session.state ? (
                    <small id="errorSelect" className="form-text text-danger">
                      Il campo non può essere vuoto!
                    </small>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              <div className="row mt-4 mb-2">
                <div className="col-lg-4">
                  <Input
                    id="nomeMyPay"
                    label={labels.nomecampo1}
                    type="text"
                    name="nomeMyPay"
                    value={session.nomeMyPay || session.nomeMyPay || ""}
                    onChange={(e) =>
                      setSession({ ...session, nomeMyPay: e.target.value })
                    }
                    {...(validation &&
                      !session.nomeMyPay && {
                        infoText: "Il campo non può essere vuoto!",
                        className: "text-danger error_div is-invalid",
                      })}
                  />
                </div>
                <div className="col-lg-4">
                  <Input
                    id="codAccertamento"
                    label="Codice Accertamento*"
                    type="text"
                    name="codAccertamento"
                    value={
                      session.codAccertamento || session.codAccertamento || ""
                    }
                    onChange={(e) =>
                      setSession({
                        ...session,
                        codAccertamento: e.target.value,
                      })
                    }
                    {...(validation &&
                      !session.codAccertamento && {
                        infoText: "Il campo non può essere vuoto!",
                        className: "text-danger error_div is-invalid",
                      })}
                  />
                </div>
                <div className="col-lg-4">
                  <Input
                    id="codCapitolo"
                    label="Codice Capitolo*"
                    type="text"
                    name="codCapitolo"
                    value={session.codCapitolo || session.codCapitolo || ""}
                    onChange={(e) =>
                      setSession({ ...session, codCapitolo: e.target.value })
                    }
                    {...(validation &&
                      !session.codCapitolo && {
                        infoText: "Il campo non può essere vuoto!",
                        className: "text-danger error_div is-invalid",
                      })}
                  />
                </div>
              </div>

              <div className="row  mb-2">
                <div className="bootstrap-select-wrapper col-lg-8">
                  <Select
                    aria-label={labels.versioneServizio}
                    name="externalId"
                    id="externalId"
                    options={[
                      { value: "", label: "Nessun valore" }, // Opzione vuota
                      ...versioneServizio,
                    ]}
                    value={
                      versioneServizio?.find(
                        (option) => option.value === session.externalId,
                      ) || { value: "", label: "Nessun valore" }
                    }
                    onChange={(e) => {
                      setSession({ ...session, externalId: e.value || null });
                    }}
                    placeholder="Seleziona modulo da associare"
                  />
                  {!session.externalId && (
                    <p className="text-muted">Nessun valore associato</p>
                  )}
                </div>
                <div className="col-lg-4">
                  <Input
                    id="externalId"
                    label={labels.versioneServizio}
                    type="text"
                    name="externalId"
                    readonly
                    value={session.externalId || null} // Mostra stringa vuota se il valore è null
                    onChange={(e) => {
                      const value = e.target.value || null; // Imposta null se il campo è vuoto
                      setSession({ ...session, externalId: value });
                    }}
                  />
                </div>
              </div>

              {transferBlock()}

              <div className="row mt-5">
                <div className="col-lg-12 text-right">
                  <button
                    type="button"
                    className="btn btn-primary"
                    data-toggle="tooltip"
                    data-placement="top"
                    onClick={() => checkSession()}
                    title="Conferma"
                  >
                    Conferma
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ModalComponent
        toggleModal={toggleModal}
        isOpen={isOpen}
        header="Inserimento nuovo bando"
        body="Confermi di voler modificare il bando?"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => postUpdateSession()}
      ></ModalComponent>
      {!loading && <Loader></Loader>}
    </>
  );
}

export default EditAnnouncement;
